import type { QuestionTurnResult } from '@/shared-responder-v2-core';
import {
  getPanelRedirectUrl,
  resolvePanelRedirectStatus,
  type ResponderPanel,
} from '@/shared-survey';

interface PanelRuleActions {
  readonly preActivationActionType?: string | null;
  readonly postActivationActionType?: string | null;
}

// The backend sends panel rules without a URL: the respondent id it needs
// lives only in the entry link.
export function resolvePanelRedirect(
  actions: PanelRuleActions | null | undefined,
  isConversationOver: boolean,
  panel: ResponderPanel | null
): string | null {
  if (panel === null) {
    return null;
  }

  const status =
    resolvePanelRedirectStatus(actions?.preActivationActionType, false) ??
    resolvePanelRedirectStatus(
      actions?.postActivationActionType,
      isConversationOver
    );

  return status === null ? null : getPanelRedirectUrl(status, panel);
}

// A panel respondent sent anywhere but the panel is never recorded by it.
export function withPanelRedirect(
  result: QuestionTurnResult,
  panelRedirectUrl: string | null
): QuestionTurnResult {
  if (panelRedirectUrl === null) {
    return result;
  }

  return {
    ...result,
    actions: [
      ...result.actions.filter(
        (action) => action.type !== 'screenOut' && action.type !== 'redirect'
      ),
      { type: 'redirect', url: panelRedirectUrl },
    ],
  };
}

export function resolvePanelCompletionRedirect(
  panel: ResponderPanel | null
): string | null {
  return panel === null ? null : getPanelRedirectUrl('COMPLETE', panel);
}
